<template>
  <div class="container-fluid">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'FieldLayout'
}
</script>

<style scoped>
</style>
